import { PropsWithChildren } from 'react';
import { Box, useTheme } from '@mui/material';
import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import { Header } from './Header';
import { mgprisHeaderHeight } from '@shared/styles';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { MGPrisLogo } from './MGPrisLogo';
import { useNavRoutes } from './useNavRoutes';
import { AppSidebar } from './AppSidebar';

export function AppLayout({ children }: PropsWithChildren) {
  const { orgUnitType } = useSelectedOrgUnit();

  const theme = useTheme();
  const navRoutes = useNavRoutes();

  return (
    <Box display="flex" flexGrow="1">
      <Header
        appLogo={
          <MGPrisLogo
            orgType={orgUnitType}
            backgroundColor={
              orgUnitType.level === 'BRAND' ? theme.vars.palette.secondary.dark : undefined
            }
          />
        }
      />
      <AppSidebar navRoutes={navRoutes} />

      <Box display="flex" flexDirection="column" flexGrow="1" marginTop={mgprisHeaderHeight}>
        <SuspenseWithSentryErrorBoundary>{children}</SuspenseWithSentryErrorBoundary>
      </Box>
    </Box>
  );
}
